import React from 'react';
import { makeStyles, Tooltip } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import { HistoryOutlined } from '@material-ui/icons';
import RecordHistoryDialog from './RecordHistoryDialog';

const useStyles = makeStyles((theme) => ({
  fabStyle: {
    backgroundColor: theme.palette.secondary.main,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.chipBg,
    },
  },
}));
const RecordHistory = (props) => {
  const classes = useStyles();
  const {
    disabled = false,
    tooltipText = 'Record History',
    showRecordHistory,
    setShowRecordHistory,
    handleCloseRecordHistoryDialog,
    createUpdateInfo,
    children,
  } = props;
  return (
    <>
      <Tooltip title={tooltipText}>
        <Fab
          onClick={() => setShowRecordHistory(true)}
          disabled={disabled}
          //style={{ marginLeft: '10px' }}
          size="small"
          color="secondary"
          className={classes.fabStyle}>
          <HistoryOutlined />
        </Fab>
      </Tooltip>

      <RecordHistoryDialog
        openEditHistoryDialog={showRecordHistory}
        onCloseEditHistoryDialog={handleCloseRecordHistoryDialog}
        createUpdateInfo={createUpdateInfo}>
        {children}
      </RecordHistoryDialog>
    </>
  );
};

export default RecordHistory;
